import type { ProjectMessage } from "./types";

/** Display name of a message's author — full name, else email, else "Unknown".
 *  Mirrors getDisplayName for issue comments. */
export function messageAuthorName(message: ProjectMessage): string {
  const a = message.author;
  if (!a) return "Unknown";
  return `${a.first_name ?? ""} ${a.last_name ?? ""}`.trim() || a.email;
}
